import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <style>{`
        .terms-container {
          max-width: 1000px;
          margin: 50px auto;
          padding: 40px 30px;
          background-color: #fff;
          border-radius: 15px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          color: #333;
          font-family: 'Poppins', sans-serif;
          line-height: 1.8;
        }
        
        .terms-container h1 {
          font-size: 36px;
          color: #b22222;
          text-align: center;
          margin-bottom: 30px;
          position: relative;
        }

        .terms-container h1::after {
          content: "";
          display: block;
          width: 80px;
          height: 4px;
          background-color: #b22222;
          margin: 15px auto 0;
          border-radius: 2px;
        }

        .terms-container h2 {
          font-size: 26px;
          color: #8b0000;
          margin: 30px 0 15px;
        }

        .terms-container p {
          font-size: 17px;
          color: #555;
          margin-bottom: 20px;
        }

        .terms-container ul {
          list-style-type: disc;
          padding-left: 25px;
        }

        .terms-container li {
          background: #fafafa;
          padding: 15px;
          border-left: 5px solid #b22222;
          border-radius: 8px;
          margin-bottom: 15px;
          transition: background 0.3s;
        }

        .terms-container li:hover {
          background: #ffecec;
        }

        .terms-container strong {
          color: #8b0000;
        }

        .terms-container a {
          color: #b22222;
          text-decoration: none;
          font-weight: 500;
        }

        .terms-container a:hover {
          text-decoration: underline;
        }

        .contact-details {
          background-color: #f9f9f9;
          padding: 20px;
          border-radius: 12px;
          margin-top: 40px;
          font-size: 16px;
          color: #444;
        }

        .thank-you {
          text-align: center;
          background-color: #ffecec;
          padding: 20px;
          margin-top: 30px;
          border-radius: 12px;
          font-weight: 600;
          color: #8b0000;
          font-size: 18px;
        }

        @media (max-width: 992px) {
          .terms-container {
            padding: 30px 20px;
          }

          .terms-container h1 {
            font-size: 30px;
          }

          .terms-container h2 {
            font-size: 22px;
          }

          .terms-container p,
          .terms-container li {
            font-size: 16px;
          }
        }

        @media (max-width: 600px) {
          .terms-container {
            padding: 20px 15px;
          }

          .terms-container h1 {
            font-size: 26px;
          }

          .terms-container h2 {
            font-size: 20px;
          }

          .terms-container p,
          .terms-container li {
            font-size: 15px;
          }

          .thank-you {
            font-size: 16px;
          }
        }
      `}</style>

      <h1>Terms and Conditions</h1>
      <p>Last Updated: March 19, 2025</p>

      <p>
        Welcome to <strong>Amman Sweets</strong>. By accessing our website or purchasing from us, you agree to the following Terms and Conditions. Please read them carefully before using our services.
      </p>

      <h2>1. General Overview</h2>
      <p>This website is operated by <strong>Amman Sweets</strong>. The terms "we", "us", and "our" refer to Amman Sweets. By visiting our website or purchasing from us, you engage in our service and agree to be bound by these terms.</p>

      <h2>2. Product Information</h2>
      <p>All images of sweets and products displayed on our website are for illustration purposes only. Actual products may vary slightly in appearance. Ingredients, weight, and flavors are subject to change based on availability and seasonality.</p>

      <h2>3. Orders and Pricing</h2>
      <ul>
        <li>All orders are subject to availability and confirmation.</li>
        <li>Prices listed are inclusive of applicable taxes unless stated otherwise.</li>
        <li>We reserve the right to change product prices and discontinue products without prior notice.</li>
      </ul>

      <h2>4. Payment</h2>
      <p>Payments must be made in full at the time of placing the order. We accept online payments via secure payment gateways. Cash on delivery is available only for eligible locations.</p>

      <h2>5. Delivery and Pickup</h2>
      <ul>
        <li>Delivery is available within specified locations and time slots.</li>
        <li>We are not responsible for delays caused by unforeseen circumstances or events beyond our control.</li>
        <li>Pickup orders must be collected within the specified time. Uncollected orders will not be refunded.</li>
      </ul>

      <h2>6. Cancellation and Refund Policy</h2>
      <ul>
        <li>Orders can be canceled within 1 hour of placing the order.</li>
        <li>Once preparation has started, cancellation or refund is not applicable.</li>
        <li>Refunds, if approved, will be processed within 5-7 business days.</li>
      </ul>

      <h2>7. Allergies and Dietary Restrictions</h2>
      <p>Our products may contain nuts, dairy, gluten, and other allergens. Customers with allergies or dietary restrictions are requested to contact us before placing an order. We are not liable for any allergic reactions.</p>

      <h2>8. Intellectual Property</h2>
      <p>All content on this website, including logos, images, text, and product designs, are the property of Amman Sweets. Unauthorized use or reproduction is strictly prohibited.</p>

      <h2>9. Privacy Policy</h2>
      <p>We respect your privacy and protect your personal data. Please refer to our Privacy Policy for more information on how we collect, use, and store your information.</p>

      <h2>10. Changes to Terms and Conditions</h2>
      <p>Amman Sweets reserves the right to update or modify these Terms and Conditions at any time without prior notice. Please review them regularly.</p>

      <h2>11. Contact Us</h2>
      <div className="contact-details">
        For any questions regarding these Terms and Conditions, please contact us at:
        <br />
        <strong>Phone:</strong> +91 7010490133
        <br />
        <strong>Email:</strong> sriammansweets@gmail.com
      </div>

      <div className="thank-you">
        Thank you for choosing Amman Sweets!
      </div>
    </div>
  );
};

export default TermsAndConditions;
